module.exports = __webpack_public_path__ + "53d9b4a37b1d9098147785c72785d08d.svg";